export enum EPageName {
  LandingSeller = 'landingSeller',
  LandingBuyer = 'landingBuyer',
}
